module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 199
// module chunks = 4 8 13 17 23 27 31 35 36 55 60